import { Component, Event, EventEmitter, getElement, h, Method, Prop } from '@stencil/core';

export declare type SubscribeConsumerEventData = {
  context: string;
  el: any;
};

/**
 * @slot - Element that will consume the context.
 */
@Component({
  tag: 'sy-context-consumer',
  shadow: true,
})
export class ContextConsumer {
  private value: any;

  /**
   * Context identifier
   */
  @Prop({ reflect: true }) context: string;

  /**
   * Unsubscribe function
   */
  @Prop({ mutable: true }) unsubscribe: { (): void } | null = null;

  /**
   * Used by a context provide to trigger a value change
   */
  @Method()
  async changeValue(newValue: any): Promise<void> {
    if (this.value !== newValue) {
      this.syContextDidChange.emit(newValue);
    }

    this.value = newValue;
  }

  /**
   * Emitted after the context consumer is connected to subscribe in a context provider
   */
  @Event({ bubbles: true, composed: true }) syContextConsumerDidSubscribe: EventEmitter<SubscribeConsumerEventData>;

  /**
   * Emitted when the context value changes.
   */
  @Event() syContextDidChange: EventEmitter<any>;

  private subscribe() {
    this.syContextConsumerDidSubscribe.emit({
      context: this.context,
      el: getElement(this),
    });
  }

  connectedCallback() {
    this.subscribe();
  }

  componentWillLoad() {
    this.subscribe();
  }

  disconnectedCallback() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
  }

  render() {
    return <slot />;
  }
}
